module.exports = __webpack_public_path__ + "fonts/2F59F3_9_0.1a262dc.woff2";